import { FacilityDropdownInput } from "#src/batteries-included-components/Dropdowns/FacilityDropdownInput";
import { useListCustomAttributes } from "#src/components/hooks/adapters/useCustomAttributes";
import { useCustomAttributeFilters } from "#src/components/hooks/FilterPanel/useCustomAttributeFilters";
import useLocalization from "#src/hooks/useLocalization";
import { DropdownInput } from "@validereinc/common-components";
import {
  AssetType,
  FacilitySchema,
  getSchemaPropertyReference,
} from "@validereinc/domain";
import { Facilities } from "@validereinc/domain-controllers";
import React from "react";

const STATIC_FACILITY_FILTERS = [
  {
    display_name: "Name",
    field_name: "name",
    data_type: "string",
  },
  {
    display_name: "Status",
    field_name: "status",
    data_type: "lookup",
    lookup_type: "facilityStatus",
  },
];

export const useFacilityFilters = () => {
  const { data, isLoading } = useListCustomAttributes({
    filters: { entity_type: AssetType.FACILITY },
  });
  return isLoading
    ? []
    : [
        ...STATIC_FACILITY_FILTERS,
        ...(data?.data.map(({ field_name, ...restOption }) => ({
          ...restOption,
          field_name: `custom_attributes.${field_name}`,
        })) ?? []),
      ];
};

const FacilityKeys = {
  name: getSchemaPropertyReference(FacilitySchema, "name", ["facility"]),
  status: getSchemaPropertyReference(FacilitySchema, "status", ["facility"]),
};

export const useFacilityCalculationFilters = () => {
  const { localize } = useLocalization();

  const localizedFacilityLabel = localize("Facility");

  const { customAttributeFilters: facilityCustomAttributeFilters } =
    useCustomAttributeFilters({
      assetType: AssetType.FACILITY,
      section: localizedFacilityLabel,
      prefix: "facility.custom_attributes",
    });

  return {
    filters: [
      {
        section: localizedFacilityLabel,
        component: (
          <FacilityDropdownInput
            key={FacilityKeys.name}
            name={FacilityKeys.name}
            label={localizedFacilityLabel}
            isMulti
            isFluid
            isOptionalTextShown={false}
          />
        ),
      },
      {
        section: localizedFacilityLabel,
        component: (
          <DropdownInput
            key={FacilityKeys.status}
            name={FacilityKeys.status}
            label={`${localizedFacilityLabel} Status`}
            options={Facilities.view.FacilityStatusOptions}
            labelKey="label"
            valueKey="value"
            isMulti
            isFluid
            isSearchable
            isOptionalTextShown={false}
          />
        ),
      },
      ...(facilityCustomAttributeFilters ?? []),
    ],
    filterKeys: [localizedFacilityLabel],
  };
};
